import React from "react";
import {useForm} from "react-hook-form";
import moment from "moment";
import ServiceService from "@/modules/front/services/ServiceService";
import ProductService from "@/modules/front/services/ProductService";


const ReservationExternalStepExtras = (props) => {
    const [loading, setLoading] = React.useState(true);

    const [services, setServices] = React.useState([]);
    const [selectedServices, setSelectedServices] = React.useState([]); // [{id, quantity}]

    const [items, setItems] = React.useState([]);
    const [selectedItems, setSelectedItems] = React.useState([]); // [{id, quantity}]

    React.useEffect(() => {
        ServiceService.getAll(props.itemId).then((response) => {
            setServices(response);
        }).catch((error) => {
            console.error('Error:', error);
            alert('Nepodařilo se načíst služby.');
        }
        ).finally(() => {
            setLoading(false);
        });

        ProductService.getRecommendedItems(props.itemId, props.dateFrom, props.dateTo)
            .then((data) => {
                const itemsArray = Object.keys(data).map((key) => data[key]);
                setItems(itemsArray);

                // Položka nabídnutá jako příslušenství, která je totožná s položkou
                // vybranou v kroku 1 (kalendář), tam už fakticky je jako 1 ks –
                // předvyplníme ji, ať to nepůsobí jako volitelný doplněk navíc.
                const mainItem = itemsArray.find((item) => String(item.id) === String(props.itemId));
                if (mainItem) {
                    setSelectedItems((prev) => {
                        if (prev.some((s) => s.id === mainItem.id)) {
                            return prev;
                        }
                        return [...prev, {id: mainItem.id, quantity: 1}];
                    });
                }
            });


    }, []);

    React.useEffect(() => {
        if (props.setSelectedServices) {
            props.setSelectedServices(selectedServices, services, selectedItems, items);
        }
    }, [selectedServices, selectedItems]);

    const setServiceQuantity = (serviceId, quantity) => {
        setSelectedServices((prev) => {
            const without = prev.filter((s) => s.id !== serviceId);
            if (quantity > 0) {
                return [...without, {id: serviceId, quantity}];
            }
            return without;
        });
    };

    const toggleServiceCheckbox = (serviceId, checked) => {
        setSelectedServices((prev) => {
            if (checked) {
                return [...prev.filter((s) => s.id !== serviceId), {id: serviceId, quantity: 1}];
            }
            return prev.filter((s) => s.id !== serviceId);
        });
    };

    const getServiceQuantity = (serviceId) => {
        const found = selectedServices.find((s) => s.id === serviceId);
        return found ? found.quantity : 0;
    };

    const isMainItem = (itemId) => String(itemId) === String(props.itemId);

    const setItemQuantity = (itemId, quantity, maxQuantity) => {
        const min = isMainItem(itemId) ? 1 : 0;
        const capped = Math.min(Math.max(quantity, min), maxQuantity || 999);
        setSelectedItems((prev) => {
            const without = prev.filter((s) => s.id !== itemId);
            if (capped > 0) {
                return [...without, {id: itemId, quantity: capped}];
            }
            return without;
        });
    };

    const toggleItemCheckbox = (itemId, checked) => {
        if (isMainItem(itemId) && !checked) {
            // Tenhle kus je už součástí rezervace z kalendáře, nejde odebrat zde.
            return;
        }
        setSelectedItems((prev) => {
            if (checked) {
                return [...prev.filter((s) => s.id !== itemId), {id: itemId, quantity: 1}];
            }
            return prev.filter((s) => s.id !== itemId);
        });
    };

    const getItemQuantity = (itemId) => {
        const found = selectedItems.find((s) => s.id === itemId);
        return found ? found.quantity : 0;
    };


    return <>
        <h2 className={'h5 mt-3 text-uppercase'}>{window.translations.reservationExternal.extras}</h2>
        {loading && <div className={'text-center mt-5'}> Načítám...</div>}
        {!loading && items && items.map((item) => {
            const qty = getItemQuantity(item.id);
            const maxQty = item.availableQuantity != null ? item.availableQuantity : 999;
            const unavailable = item.availableQuantity != null && item.availableQuantity <= 0;
            const mainItem = isMainItem(item.id);
            const minQty = mainItem ? 1 : 0;
            return <div className={'bg-light p-3 mt-3' + (unavailable ? ' item-unavailable opacity-50' : '')} key={item.id}>
                {item.displayAsQuantity ? (
                    <div className="d-flex align-items-start justify-content-between">
                        <div>
                            <div>{item.product.title} ({item.pricePerDayFormatted} / {item.product.unit || 'den'})</div>
                            {item.product.description_short && <div className="small text-muted mt-1" dangerouslySetInnerHTML={{__html: item.product.description_short}}/>}
                            {item.availableQuantity != null && <div className="item-available-quantity small text-muted mt-1">Dostupný počet: {item.availableQuantity}</div>}
                        </div>
                        <div className="d-flex align-items-center gap-2 ms-3 flex-shrink-0">
                            <button type="button" className="btn btn-secondary btn-sm px-2" disabled={unavailable || qty <= minQty}
                                    onClick={() => setItemQuantity(item.id, Math.max(minQty, qty - 1), maxQty)}>−</button>
                            <span className="px-2">{qty}</span>
                            <button type="button" className="btn btn-secondary btn-sm px-2" disabled={unavailable}
                                    onClick={() => setItemQuantity(item.id, qty + 1, maxQty)}>+</button>
                        </div>
                    </div>
                ) : (
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value={item.id} id={`item-${item.id}`}
                               checked={qty > 0} disabled={unavailable || mainItem}
                               onChange={(e) => toggleItemCheckbox(item.id, e.target.checked)}/>
                        <div>
                            <label className="form-check-label" htmlFor={`item-${item.id}`}>
                                {item.product.title} ({item.pricePerDayFormatted} / {item.product.unit || 'den'})
                            </label>
                            {item.product.description_short && <div className="small text-muted mt-1" dangerouslySetInnerHTML={{__html: item.product.description_short}}/>}
                        </div>
                    </div>
                )}
            </div>;
        })}
        {!loading && services && services.map((service) => {
            const qty = getServiceQuantity(service.id);
            return <div className={'bg-light p-3 mt-3'} key={service.id}>
                {service.displayAsCheckbox ? (
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value={service.id} id={`service-${service.id}`}
                               checked={qty > 0}
                               onChange={(e) => toggleServiceCheckbox(service.id, e.target.checked)}/>
                        <div>
                            <label className="form-check-label" htmlFor={`service-${service.id}`}>
                                {service.name} ({service.priceFormatted}{service.unit ? ` / ${service.unit}` : ''})
                            </label>
                            {service.description && <div className="small text-muted mt-1" dangerouslySetInnerHTML={{__html: service.description}}/>}
                        </div>
                    </div>
                ) : (
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <span>{service.name} ({service.priceFormatted}{service.unit ? ` / ${service.unit}` : ''})</span>
                            {service.description && <div className="small text-muted mt-1" dangerouslySetInnerHTML={{__html: service.description}}/>}
                        </div>
                        <div className="d-flex align-items-center gap-2 ms-3 flex-shrink-0">
                            <button type="button" className="btn btn-secondary btn-sm px-2"
                                    onClick={() => setServiceQuantity(service.id, Math.max(0, qty - 1))}>−</button>
                            <span className="px-2">{qty}</span>
                            <button type="button" className="btn btn-secondary btn-sm px-2"
                                    onClick={() => setServiceQuantity(service.id, qty + 1)}>+</button>
                        </div>
                    </div>
                )}
            </div>;
        })}

        {!loading && props.pricingNote &&
        <div className={'small text-black mb-3 me-2 mt-2'}>
            {props.pricingNote}
        </div>}



        <div className={'d-flex justify-content-between mt-4'}>
            <span className={'btn btn-light px-4 py-2 rounded-0 me-3'} onClick={props.onBack}><i
                className="fas fa-chevron-left me-3"></i> {window.translations.reservationExternal.back}</span>
            <span className={'btn btn-primary px-4 py-2 rounded-0'} onClick={props.onNext}>{window.translations.reservationExternal.next} <i
                className="fas fa-chevron-right ms-3"></i></span>
        </div>
    </>;

};

export default ReservationExternalStepExtras;
